import { type FC, useRef, useState } from 'react';
import { Button, Collapse, Overlay, Tooltip } from 'react-bootstrap';
import { classes } from 'typestyle';
import type { CampaignErrorsProps } from './CampaignErrorsTypes';

export const CampaignErrors: FC<CampaignErrorsProps> = ({ errors }) => {
  const [areErrorsExpanded, setAreErrorsExpanded] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const target = useRef(null);

  return (
    <div>
      {errors && errors.length > 0 && (
        <>
          <div
            className={classes('pt-2 pb-2 pod-status', {
              'errors-collapsed': !areErrorsExpanded,
              'errors-expanded': areErrorsExpanded,
            })}
            v-if="(errors && errors.length > 0)"
          >
            <Button className="mr-3" onClick={() => setAreErrorsExpanded(!areErrorsExpanded)} variant="danger">
              <i className="fa fa-caret-right collapse-icon" />
              Errors
              <span className="btn-subtext">({errors.length})</span>
            </Button>
          </div>

          <Collapse in={areErrorsExpanded}>
            <div className="card mb-3 border-danger">
              <ul className="list-group list-group-flush">
                {errors.map((error, n) => (
                  <li className="list-group-item" key={error + n.toString()}>
                    {error.message}

                    {error.originalMessage && (
                      <Button onClick={() => setShowMore(!showMore)} ref={target} type="button" variant="secondary">
                        More...
                      </Button>
                    )}
                    <Overlay placement="bottom" show={showMore} target={target.current}>
                      {(props) => (
                        <Tooltip id="show-more" {...props}>
                          {error.originalMessage}
                        </Tooltip>
                      )}
                    </Overlay>
                  </li>
                ))}
              </ul>
            </div>
          </Collapse>
        </>
      )}
    </div>
  );
};
